export default "__VITE_ASSET__fb0f8c1c__"